
























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';

// Interfaces for structured dynamic variables and API response
interface DynamicVariables {
  entity_id?: number;
  entity_name?: string;
  entity_key?: string;
  call_id?: number;
  call_public_id?: string;
  flow_id?: number;
  flow_public_id?: string;
  [key: string]: unknown;
}

interface SessionResponse {
  success: boolean;
  signed_url?: string;
  dynamic_variables?: DynamicVariables;
  error?: string;
}

@Component
export default class WidgetView extends Vue {
  @Prop({ type: String, required: true }) readonly entity_key!: string;
  @Prop({ type: String, required: true }) readonly agent_id!: string;

  private readonly API_HOST = process.env.VUE_APP_ROOT_API || '/widget-api';

  loading = false;
  errorMessage: string | null = null;
  isWidgetActive = false;
  entityName = '';

  async mounted() {
    this.injectWidgetScript();
    await this.startSession();
  }

  private injectWidgetScript(): void {
    const scriptId = 'elevenlabs-convai-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
      script.async = true;
      document.head.appendChild(script);
    }
  }

  async startSession(): Promise<void> {
    this.loading = true;
    this.errorMessage = null;

    try {
      const formData = new FormData();
      formData.append('entity_key', this.entity_key);
      formData.append('agent_id', this.agent_id);

      const response: AxiosResponse<SessionResponse> = await this.axios.post(
        `${this.API_HOST}/callcenter/ai/widget/session`,
        formData
      );

      const data = response.data;

      if (!data.success || !data.signed_url) {
        this.errorMessage = data.error || 'Unspecified server error.';
        return;
      }

      // Extract entity_name from dynamic_variables
      if (data.dynamic_variables?.entity_name) {
        this.entityName = data.dynamic_variables.entity_name;
      }

      this.mountWidget(data.signed_url, data.dynamic_variables);
      this.isWidgetActive = true;

    } catch (error) {
      console.error('Failed to request session:', error);
      this.errorMessage = 'Could not connect to the application server.';
    } finally {
      this.loading = false;
    }
  }

  private mountWidget(signedUrl: string, dynamicVariables?: DynamicVariables): void {
    const container = this.$refs.widgetContainer as HTMLElement;
    if (!container) return;

    container.innerHTML = '';

    const widget = document.createElement('elevenlabs-convai');
    widget.setAttribute('signed-url', signedUrl);
    
    if (dynamicVariables) {
      widget.setAttribute('dynamic-variables', JSON.stringify(dynamicVariables));
    }
    
    widget.setAttribute('variant', 'expanded');
    container.appendChild(widget);
  }
}
